import styled from 'styled-components'

const Spinner = styled.div<SpinnerProps>`
  margin: auto;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  border-style: solid solid solid;
  border-width: 0.175em;
  border-color: ${({ color }) => color};
  border-left-color: transparent;
  border-bottom-color: transparent;
  animation: spin 1.2s ease-out infinite;
  box-sizing: border-box;
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`

export default Spinner

interface SpinnerProps {
  color: string
}
